import {EnumTypLayerAttr} from '../api';

export const getEnumTypLayerAttr = (typ: string | EnumTypLayerAttr): string => {
    switch (typ) {
        case EnumTypLayerAttr.STRING:
            return 'Varchar';
        case EnumTypLayerAttr.INT:
            return 'Integer';
        case EnumTypLayerAttr.NUMBER:
            return 'Numeric 14.2';
        case EnumTypLayerAttr.BOOLEAN:
            return 'Boolean';
        case EnumTypLayerAttr.TEXT:
            return 'Text';
        case EnumTypLayerAttr.ENUM:
            return 'Enum';
        case EnumTypLayerAttr.ACCESSIBILITY:
            return 'Accessibility';
        default:
            return `_${typ}`;
    }
};

export const getEnumTypLayerAttrReadable = (typ: string | EnumTypLayerAttr): string => {
    switch (typ) {
        case EnumTypLayerAttr.STRING:
            return 'Jednořádkový text';
        case EnumTypLayerAttr.INT:
            return 'Číslo';
        case EnumTypLayerAttr.NUMBER:
            return 'Desetinné číslo';
        case EnumTypLayerAttr.BOOLEAN:
            return 'Ano/Ne';
        case EnumTypLayerAttr.TEXT:
            return 'Dlouhý text';
        case EnumTypLayerAttr.ENUM:
            return 'Číselník';
        case EnumTypLayerAttr.DATE_TIME:
            return 'Datum a čas';
        case EnumTypLayerAttr.ACCESSIBILITY:
            return 'Přístupnost pro vozíčkáře';
        default:
            return `_${typ}`;
    }
};

export const getDokumentZdrojItems = (): {id: EnumTypLayerAttr; name: string}[] => {
    return Object.keys(EnumTypLayerAttr)
        .map((t: EnumTypLayerAttr) => ({id: t, name: getEnumTypLayerAttr(t)}))
        .sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * @param atlasPristupnosti MCW-29581 – typ „Přístupnost pro vozíčkáře“ nabízíme jen organizaci
 *        se zapnutým atlasem přístupnosti. Parametr je povinný, ať se na něj nezapomene.
 */
export const getDokumentZdrojItemsReadable = (atlasPristupnosti: boolean): {id: EnumTypLayerAttr; name: string}[] => {
    return Object.keys(EnumTypLayerAttr)
        .filter((t: EnumTypLayerAttr) => atlasPristupnosti || t !== EnumTypLayerAttr.ACCESSIBILITY)
        .map((t: EnumTypLayerAttr) => ({id: t, name: getEnumTypLayerAttrReadable(t)}));
};
